import { render, staticRenderFns } from "./usersTable.vue?vue&type=template&id=1bcc3d40&"
import script from "./usersTable.vue?vue&type=script&lang=ts&"
export * from "./usersTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports